import Checkbox from '@liveauctioneers/caterwaul-components/lib/Checkbox/Checkbox';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import React from 'react';
import styled from 'styled-components';

type StatusProps = {
    checked: boolean;
    indeterminate: boolean;
};

const getCheckboxStatus = (array: any, selector: (input: any) => boolean): StatusProps => {
    const expectedNumber = array.length;
    const actualNumber = array.filter(selector).length;
    if (expectedNumber === 0 || actualNumber === 0) {
        return { checked: false, indeterminate: false };
    }
    if (expectedNumber === actualNumber) {
        return { checked: true, indeterminate: false };
    } else {
        return { checked: false, indeterminate: true };
    }
};

type Props = {
    array: any;
    category: string;
    onChange: (checkedOrIndeterminate: boolean) => void;
    selector: (input: any) => boolean;
    type: string;
};

const StatusCheckbox = ({ array, category, onChange, selector, type }: Props) => {
    const { formatMessage } = useIntl();
    const props = getCheckboxStatus(array, selector);
    return (
        <StyledCheckbox
            label={formatMessage({ id: 'notificationsPage.toggleAllNotifcations' }, { name: category, type })}
            labelDisplay=""
            name="statusCheckbox"
            onClick={() => onChange(props.checked || props.indeterminate)}
            {...props}
        />
    );
};

const StyledCheckbox = styled(Checkbox)`
    align-self: center;
    margin-bottom: 0;
`;

export default React.memo<Props>(StatusCheckbox);
